<script>
export default {
  props: {
    socialProfiles: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      socialMediaLinks: [
        { key: 'facebook', link: 'https://facebook.com/' },
        { key: 'twitter', link: 'https://twitter.com/' },
        { key: 'linkedin', link: 'https://linkedin.com/' },
        { key: 'github', link: 'https://github.com/' },
        { key: 'instagram', link: 'https://instagram.com/' },
        { key: 'telegram', link: 'https://t.me/' },
        { key: 'tiktok', link: 'https://tiktok.com/@' },
        { key: 'line', icon: 'brand-line', link: 'https://line.me/R/ti/p/~' },
        { key: 'phone', icon: 'brand-whatsapp', link: 'https://wa.me/' },
        { key: 'website', icon: 'globe', link: 'https://' },
      ],
    };
  },
  computed: {
    availableProfiles() {
      return this.socialMediaLinks.filter(
        mediaLink => !!this.socialProfiles[mediaLink.key]
      );
    },
  },
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <div v-if="availableProfiles.length" class="flex items-end gap-3 mx-0 my-2">
    <a
      v-for="profile in availableProfiles"
      :key="profile.key"
      :href="`${profile.link}${socialProfiles[profile.key]}`"
      target="_blank"
      rel="noopener noreferrer nofollow"
    >
      <fluent-icon
        :icon="profile.icon || `brand-${profile.key}`"
        size="16"
        class="text-n-slate-11 hover:text-n-slate-10"
      />
    </a>
  </div>
</template>
